export default "__VITE_ASSET__BEwfhcXr__"